import { FC } from 'react';
import { formatDate } from '../../../../services/utils/DateUtils';
import { StyledButton, StyledInput, StyledSpan } from './Style';

type ReactivateDealFormFieldProps = {
  inputValue: string | number;
  labelValue: string;
  fieldName: string;
  hasLabel?: boolean;
  hasInputAddOn?: boolean;
  hasWrapperClass?: boolean;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  isInputWrapper?: boolean;
  isDateField?: boolean;
  isCalendarDisabled?: boolean;
  min?: number;
  max?: number;
  applyPadding?: boolean;
};

const ReactivateDealFormField: FC<ReactivateDealFormFieldProps> = (props) => {
  const hasWrapperClass = props?.hasWrapperClass === false;
  const hasLabel = props?.hasLabel === false;

  const dateValue =
    props.inputValue !== null ? formatDate(props?.inputValue as string, 'MM/DD/YYYY') : 'N/A';
  const value = props.inputValue === null ? 'N/A' : props.inputValue;

  return (
    <div className='value-block'>
      {!hasLabel && <label className='title-block'>{props.labelValue}</label>}
      <div className='read-only'>
        <div
          className={
            !hasWrapperClass ? (props.isInputWrapper ? 'input-wrapper' : 'input-group') : ''
          }
        >
          {props.hasInputAddOn && (
            <StyledSpan
              applyPadding={props.applyPadding ?? true}
              hasWrapperClass={props.isDateField == true ? true : (props.isInputWrapper ?? false)}
            >
              $
            </StyledSpan>
          )}
          <StyledInput
            type='text'
            id={props.fieldName}
            name={props.fieldName}
            placeholder='N/A'
            className='form-control'
            required={props.isRequired}
            value={!props.isDateField ? value : dateValue}
            min={props.min}
            max={props.max}
            readOnly={props.isReadOnly}
            onChange={() => {}}
            disabled={props.isDisabled}
          />
          {props.isDateField && (
            <StyledSpan
              applyPadding={props.applyPadding ?? true}
              hasWrapperClass={props.isDateField == true ? true : (props.isInputWrapper ?? false)}
            >
              <StyledButton className='btn btn-default' disabled={props.isCalendarDisabled}>
                <i className='am-icon am-icon-calendar' />
              </StyledButton>
            </StyledSpan>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReactivateDealFormField;
